@if (kirjanpitajaOnDevaajaObservable | async) {
  <div style="padding-bottom: 20px">
    <h3 style="margin: 0">Urit</h3>
    <div style="padding-top: 1em; padding-left: 1em; padding-right: 1em">
      Käyttäjän tallentamat tiedot: <a [href]="liitetiedotEncodedUriObservable | async" target="_BLANK">{{ liitetiedotUriObservable | async }}</a>
    </div>
  </div>
}

<form>
  @if (lukittuObservable | async) {
    <div style="padding: 3em; font-weight: bold">Tilinpäätös on rekisteröity. Tietoja ei voi enää muokata.</div>
  }

  <div style="background-color: #f2f2f2; padding: 15px">
    <div style="margin: 20px 5px 0 5px">Onko yhtiö mikro- vai pienyritys?</div>
    <div style="padding: 8px 15px 0 15px">
      @if (tilikausiAlkanut2024JalkeenObservable | async) {
        <mat-checkbox [formField]="lomake.taseenLoppusummaYli" class="cb pitka-label" name="o1">{{ 'PMA1_1_5.ONKO_MIKROYRITYS_TASEEN_LOPPUSUMMA_YLI_2024_ALKAEN' | translatetilinpaatos: 2021 | async }}</mat-checkbox> <br />
        <mat-checkbox [formField]="lomake.liikevaihtoYli" class="cb pitka-label" name="o2">{{ 'PMA1_1_5.ONKO_MIKROYRITYS_LIIKEVAIHTO_YLI_2024_ALKAEN' | translatetilinpaatos: 2021 | async }}</mat-checkbox
        ><br />
        <mat-checkbox [formField]="lomake.henkilostoYli" class="cb pitka-label" name="o3">{{ 'PMA1_1_5.ONKO_MIKROYRITYS_HENKILOSTO_YLI_2024_ALKAEN' | translatetilinpaatos: 2021 | async }}</mat-checkbox
        ><br />
      } @else {
        <mat-checkbox [formField]="lomake.taseenLoppusummaYli" class="cb pitka-label" name="o1">{{ 'PMA1_1_5.ONKO_MIKROYRITYS_TASEEN_LOPPUSUMMA_YLI' | translatetilinpaatos: 2021 | async }}</mat-checkbox> <br />
        <mat-checkbox [formField]="lomake.liikevaihtoYli" class="cb pitka-label" name="o2">{{ 'PMA1_1_5.ONKO_MIKROYRITYS_LIIKEVAIHTO_YLI' | translatetilinpaatos: 2021 | async }}</mat-checkbox
        ><br />
        <mat-checkbox [formField]="lomake.henkilostoYli" class="cb pitka-label" name="o3">{{ 'PMA1_1_5.ONKO_MIKROYRITYS_HENKILOSTO_YLI' | translatetilinpaatos: 2021 | async }}</mat-checkbox
        ><br />
      }
    </div>

    <div style="font-weight: bold; margin: 15px 0 30px 15px">
      @if (onkoMikro()) {
        <div>Tilinpäätös tehdään mikroyrityssäännöstön mukaisesti.</div>
      } @else {
        Tilinpäätös tehdään pienyrityssäännöstön mukaisesti
      }
    </div>

    <div style="padding-bottom: 10px">
      <div>Tilinpäätöksessä käytettävä tuloslaskelma:</div>
      <mat-radio-group style="margin: 15px" name="tilinpaatoksenTuloslaskelma" [formField]="lomake.tilinpaatoksenTuloslaskelma">
        <mat-radio-button [value]="TilinpaatoksenTuloslaskelmanTyyppi.VIRALLINEN">Virallinen</mat-radio-button>
        <mat-radio-button [value]="TilinpaatoksenTuloslaskelmanTyyppi.BRUTTO">Brutto</mat-radio-button>
      </mat-radio-group>
    </div>
    <div>
      <!-- <div>Tällä työkalulla voit luoda tilinpäätöksen liitetiedot "tavanomaiselle" mikro-osakeyhtiölle ja siitä löytyy liitetietojen yleisimmät kohdat. Jos tilinpäätös vaatii jonkin seikan esittämistä, joka ei onnistu työkalua käyttämällä, pitää liitetiedot tehdä ohjelman ulkopuolella.</div> -->
      <label style="padding: 20px 5px 5px 5px; display: block" id="tilintarkastetaan-radio-group-label">Tilinpäätös tilintarkastetaan:</label>
      <mat-radio-group [formField]="lomake.tilintarkastetaan" aria-labelledby=" tilintarkastetaan-radio-group-label">
        <mat-radio-button [value]="true" style="margin-left: 10px; display: block">Kyllä</mat-radio-button>
        <mat-radio-button [value]="false" style="margin-left: 10px; display: block">Ei</mat-radio-button>
      </mat-radio-group>
      @if (lomake.tilintarkastetaan().value() && (tilintarkastajatObservable | async)) {
        <div style="margin-top: 15px; padding-left: 20px; padding-right: 20px">
          <!-- Tilintarkastajien näkymä -->
          <div style="margin-top: 10px; margin-bottom: 20px">
            <b>Valitse tilintarkastajat</b>
            <div style="margin-top: 10px; font-size: 13px; color: grey">
              Listalla näkyvät Lemonatoriin jo kirjautuneet tai kutsutut tilintarkastajat.<br />
              Tilintarkastaja voi kirjautua Lemonatoriin pankkitunnuksin ja saa pääsyn asiakkaan tietoihin.<br />
              <br />
              Voit valita useamman tilintarkastajan (esim. päätilintarkastaja ja aputilintarkastaja).<br />
              Tarvittaessa voit kutsua uuden tilintarkastajan järjestelmään alla olevasta linkistä.<br />
              <a (click)="avaaTilintarkastajaKutsuDialogi()" style="color: #1976d2; cursor: pointer; text-decoration: underline">Kutsu uusi tilintarkastaja</a>
            </div>
            <mat-chip-grid #tilintarkastajaChips style="margin-top: 15px">
              @for (t of lomake.tilintarkastajat().value(); track t.avain) {
                <mat-chip-row [removable]="!lomake().disabled()" (removed)="poistaTilintarkastaja(t)">
                  @if (tilintarkastajatMap().has(t.avain)) {
                    {{ t.etunimi }} {{ t.sukunimi }}
                  } @else {
                    {{ t.avain }}
                  }
                  @if (tilintarkastajatMap().get(t.avain)?.tila === 'hylatty') {
                    <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 15px; padding-left: 5px"></i>
                  }
                  @if (!lomake().disabled()) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
            <mat-form-field style="width: 100%; margin-top: 15px">
              <mat-label>Tilintarkastajat ({{ asiakasJaTilikausiStringObservable | async }})</mat-label>
              <input #tilintarkastajaInput type="text" matInput placeholder="Hae nimellä lisätäksesi" autocomplete="off" [formField]="tilintarkastajaHaku" [matChipInputFor]="tilintarkastajaChips" [matAutocomplete]="autoTilintarkastaja" />
              <mat-autocomplete #autoTilintarkastaja="matAutocomplete" (optionSelected)="lisaaTilintarkastaja($event.option.value)" [displayWith]="displayTyhja">
                @for (t of suodatetutTilintarkastajatSubject | async; track t.avain) {
                  <mat-option [value]="t">
                    {{ t.etunimi }} {{ t.sukunimi }}
                    @if (t?.tila === 'hylatty') {
                      <span>
                        <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 15px; padding-left: 3px"></i>
                      </span>
                    }
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            @for (hylatty of hylatytValitut(); track hylatty.avain) {
              <div style="margin-top: 5px">
                <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 15px; padding-right: 5px"></i>
                Tilintarkastaja {{ hylatty.etunimi }} {{ hylatty.sukunimi }} on tunnistautunut, mutta hänen nimitietonsa eivät täsmää annettuihin tietoihin. Tilintarkastaja ei ole aktiivinen. Ota yhteyttä esihenkilöön tai tukeen.
              </div>
            }
          </div>
        </div>
      }
      @if (lomake.tilintarkastetaan().touched() && onkoVirhe(lomake.tilintarkastetaan, 'required')) {
        <mat-error>Tieto tilintarkastuksesta puuttuu.</mat-error>
      }

      <label [class.mat-form-field-invalid]="lomake.allekirjoitetaanLemonaidissa().touched() && onkoVirhe(lomake.allekirjoitetaanLemonaidissa, 'required')" style="padding: 20px 5px 5px 5px; display: block" id="allekirjoitetaanLemonaidissa-radio-group-label">Tilinpäätös allekirjoitetaan Lemonaidissa:</label>
      <mat-radio-group [formField]="lomake.allekirjoitetaanLemonaidissa" aria-labelledby="allekirjoitetaanLemonaidissa-radio-group-label" name="o3445">
        <mat-radio-button [value]="true" style="margin-left: 10px; display: block">Kyllä</mat-radio-button>
        <mat-radio-button [value]="false" style="margin-left: 10px; display: block">Ei</mat-radio-button>
      </mat-radio-group>
      @if (lomake.allekirjoitetaanLemonaidissa().touched() && onkoVirhe(lomake.allekirjoitetaanLemonaidissa, 'required')) {
        <mat-error>Tieto allekirjoituksesta puuttuu.</mat-error>
      }
    </div>
  </div>
</form>

@if (!(lukittuObservable | async)) {
  <app-primary-button [disabled]="onkoVirheita(lomake.tilinpaatoksenTuloslaskelma) || onkoVirheita(lomake.tilintarkastetaan) || onkoVirheita(lomake.allekirjoitetaanLemonaidissa)" (click)="aloitaTilinpaatos()" actionId="Aloitettu tilinpäätöksen tekeminen" [actionContext]="[lomake().value()]" styles="margin: 30px 15px;"> Aloita tilinpäätöksen tekeminen </app-primary-button>
}
